import {
  ROUTE_INBOX,
  ROUTE_TASKS,
  ROUTE_TIMERS,
} from "@/constants/routes.constants";
import { Button } from "@/shadcn/components/ui/button";
import { StopwatchIcon } from "@radix-ui/react-icons";
import { CheckCircle, Inbox } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router";

type MobileFooterBarProps = {
  currPage: string;
};

const MobileFooterBar: React.FC<MobileFooterBarProps> = ({ currPage }) => {
  const nav = useNavigate();
  return (
    <div className="bg-gray-700 w-full flex-shrink-0 text-white block sm:hidden">
      <div className="p-3 grid gap-2 grid-flow-col auto-cols-fr">
        {/* Changed grid-flow-row to grid-flow-col and added auto-cols-fr for equal column width */}
        <Button
          variant={"ghost"}
          className={`bg-transparent text-left flex justify-start items-center gap-2 transition-all ${
            currPage === "tasks" ? "bg-gray-800 font-bold" : ""
          }`}
          onClick={() => nav(ROUTE_TASKS)}
        >
          <CheckCircle className="w-4" />
          Tasks
        </Button>
        <Button
          variant={"ghost"}
          className={`bg-transparent text-left flex justify-start items-center gap-2 transition-all ${
            currPage === "timers" ? "bg-gray-800 font-bold" : ""
          }`}
          onClick={() => nav(ROUTE_TIMERS)}
        >
          <StopwatchIcon className="w-4" />
          Timers
        </Button>
        <Button
          variant={"ghost"}
          className={`bg-transparent text-left flex justify-start items-center gap-2 transition-all ${
            currPage === "inbox" ? "bg-gray-800 font-bold" : ""
          }`}
          onClick={() => nav(ROUTE_INBOX)}
        >
          <Inbox className="h-4" />
          Inbox
        </Button>
      </div>
    </div>
  );
};

export default MobileFooterBar;
